"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _livenessBiometricMap = require("@/utils/livenessBiometricMap");
var _livenessDossierStatus = require("@/utils/livenessDossierStatus");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _default2 = exports.default = {
  name: 'CardValidaFace',
  components: {
    Card: _components.Card
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isImageModalActive: false,
      imgSelected: null,
      failedAttemptImages: {}
    };
  },
  computed: {
    currentFaceAttempt: function currentFaceAttempt() {
      return (0, _livenessDossierStatus.getLatestFaceAttempt)(this.data);
    },
    hasFaceContent: function hasFaceContent() {
      return Boolean(this.faceHistoryAttempts.length || this.validationFace || this.validationDate || this.biometricValidationItems.length || this.facematchScoreCard);
    },
    normalizedFaceHistoryAttempts: function normalizedFaceHistoryAttempts() {
      var _this$data,
        _this = this;
      var faceHistory = Array.isArray((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.faceHistory) ? this.data.faceHistory : [];
      var attempts = faceHistory.filter(function (attempt) {
        return attempt && _typeof(attempt) === 'object' && !Array.isArray(attempt);
      }).map(function (attempt, index) {
        return _this.normalizeFaceAttempt(attempt, index);
      }).filter(function (attempt) {
        return attempt.hasContent;
      }).sort(function (attemptA, attemptB) {
        if (attemptA.timestamp === attemptB.timestamp) {
          return attemptA.originalIndex - attemptB.originalIndex;
        }
        if (attemptA.timestamp === null) return 1;
        if (attemptB.timestamp === null) return -1;
        return attemptA.timestamp - attemptB.timestamp;
      });
      var currentResultIndex = -1;
      for (var index = attempts.length - 1; index >= 0; index -= 1) {
        if (this.isMainFaceAttempt(attempts[index], index, attempts.length)) {
          currentResultIndex = index;
          break;
        }
      }
      return attempts.map(function (attempt, index) {
        return _objectSpread(_objectSpread({}, attempt), {}, {
          key: "".concat(attempt.key, "-").concat(index),
          label: "Tentativa ".concat(index + 1),
          isCurrentResult: index === currentResultIndex
        });
      });
    },
    faceHistoryAttempts: function faceHistoryAttempts() {
      var attempts = this.normalizedFaceHistoryAttempts;
      var previousAttempts = attempts.filter(function (attempt) {
        return !attempt.isCurrentResult;
      });
      if (attempts.length > 1 && previousAttempts.length) {
        return previousAttempts.slice().reverse();
      }
      return attempts.slice().reverse();
    },
    faceHistoryDescription: function faceHistoryDescription() {
      var count = this.faceHistoryAttempts.length;
      var suffix = count === 1 ? 'tentativa disponível' : 'tentativas disponíveis';
      var currentResultWasOmitted = this.normalizedFaceHistoryAttempts.length > count;
      if (currentResultWasOmitted) {
        return "".concat(count, " ").concat(suffix, ". O resultado atual permanece destacado acima.");
      }
      return "".concat(count, " ").concat(suffix, ". O hist\xF3rico \xE9 complementar ao resultado principal.");
    },
    validationFace: function validationFace() {
      var _this$currentFaceAtte;
      return this.normalizeFaceAttemptImage((_this$currentFaceAtte = this.currentFaceAttempt) === null || _this$currentFaceAtte === void 0 ? void 0 : _this$currentFaceAtte.selfie);
    },
    validationDate: function validationDate() {
      var _this$currentFaceAtte2;
      return ((_this$currentFaceAtte2 = this.currentFaceAttempt) === null || _this$currentFaceAtte2 === void 0 ? void 0 : _this$currentFaceAtte2.createdAt) || null;
    },
    biometricEntries: function biometricEntries() {
      var _this$currentFaceAtte3;
      return (0, _livenessBiometricMap.extractBiometricEntriesFromPayload)((_this$currentFaceAtte3 = this.currentFaceAttempt) === null || _this$currentFaceAtte3 === void 0 ? void 0 : _this$currentFaceAtte3.liveness);
    },
    biometricMap: function biometricMap() {
      return this.biometricEntries.reduce(function (accumulator, item) {
        if (item !== null && item !== void 0 && item.nome) {
          accumulator[(0, _livenessBiometricMap.normalizeBiometricKey)(item.nome)] = item.valor;
        }
        return accumulator;
      }, {});
    },
    statusFieldLabel: function statusFieldLabel() {
      var statusValue = (0, _livenessBiometricMap.findBiometricValueByAliases)(this.biometricMap, ['status']);
      return (0, _livenessBiometricMap.formatBiometricProcessingStatus)(statusValue);
    },
    facematchScoreCard: function facematchScoreCard() {
      var _this$currentFaceAtte4;
      var rawScore = (_this$currentFaceAtte4 = this.currentFaceAttempt) === null || _this$currentFaceAtte4 === void 0 ? void 0 : _this$currentFaceAtte4.facematch;
      var score = Number(rawScore);
      if (rawScore === null || rawScore === undefined || Number.isNaN(score)) {
        return null;
      }
      var tone = score > 0 ? 'success' : score === 0 ? 'warning' : 'danger';
      return {
        key: 'facematch-score',
        icon: 'chart-line',
        label: 'Score de FaceMatch',
        text: "".concat(score, "%"),
        helper: this.getFacematchScoreHelper(score),
        tone: tone,
        tag: (0, _livenessBiometricMap.getDefaultBiometricTag)(tone)
      };
    },
    biometricValidationItems: function biometricValidationItems() {
      return (0, _livenessBiometricMap.buildBiometricValidationHighlights)(this.biometricMap);
    },
    summaryStatus: function summaryStatus() {
      var items = this.biometricValidationItems.filter(function (item) {
        return item.kind === 'boolean';
      });
      var hasFailure = items.some(function (item) {
        return item.tone === 'danger';
      });
      var hasSuccess = items.length && items.every(function (item) {
        return item.tone === 'success';
      });
      var statusLabel = this.statusFieldLabel;
      if (hasSuccess) {
        return {
          title: 'Biometria validada com sucesso',
          description: 'Todos os controles biométricos e de segurança retornaram resultado positivo.',
          tagLabel: 'Validado',
          tagClass: 'is-success',
          icon: 'check-circle'
        };
      }
      if (hasFailure) {
        return {
          title: 'Biometria com pontos de atenção',
          description: 'Foram identificadas falhas em uma ou mais verificações críticas da validação facial.',
          tagLabel: 'Atenção',
          tagClass: 'is-danger',
          icon: 'alert-circle'
        };
      }
      if (statusLabel === 'Concluído') {
        return {
          title: 'Validação biométrica concluída',
          description: 'A análise facial foi finalizada e os resultados disponíveis foram organizados abaixo.',
          tagLabel: 'Concluído',
          tagClass: 'is-info',
          icon: 'check-circle-outline'
        };
      }
      return {
        title: 'Validação biométrica em análise',
        description: 'Os indicadores disponíveis foram carregados e podem ser acompanhados em tempo real.',
        tagLabel: statusLabel || 'Em análise',
        tagClass: 'is-warning',
        icon: 'clock-outline'
      };
    }
  },
  methods: {
    normalizeFaceAttempt: function normalizeFaceAttempt(attempt, originalIndex) {
      var _attempt$liveness;
      var biometricMap = (0, _livenessBiometricMap.extractBiometricEntriesFromPayload)(attempt === null || attempt === void 0 ? void 0 : attempt.liveness).reduce(function (accumulator, item) {
        if (item !== null && item !== void 0 && item.nome) {
          accumulator[(0, _livenessBiometricMap.normalizeBiometricKey)(item.nome)] = item.valor;
        }
        return accumulator;
      }, {});
      var diagnostics = (0, _livenessBiometricMap.buildBiometricValidationHighlights)(biometricMap);
      var score = this.parseFaceAttemptScore(attempt === null || attempt === void 0 ? void 0 : attempt.facematch);
      var date = this.extractFaceAttemptDate(attempt);
      var timestamp = date ? new Date(date).getTime() : null;
      var rawStatus = (attempt === null || attempt === void 0 ? void 0 : attempt.status) || (attempt === null || attempt === void 0 ? void 0 : (_attempt$liveness = attempt.liveness) === null || _attempt$liveness === void 0 ? void 0 : _attempt$liveness.status);
      var statusLabel = this.formatFaceAttemptStatus(rawStatus);
      var image = this.extractFaceAttemptImage(attempt);
      var errorMessage = this.extractFaceAttemptError(attempt);
      var failureReason = this.extractFaceAttemptFailureReason({
        attempt: attempt,
        diagnostics: diagnostics,
        score: score
      });
      var resultTone = this.getFaceAttemptResultTone({
        rawStatus: rawStatus,
        diagnostics: diagnostics,
        score: score,
        errorMessage: errorMessage,
        attempt: attempt
      });
      var identifiers = [{
        label: 'ID da tentativa',
        value: attempt === null || attempt === void 0 ? void 0 : attempt._id
      }, {
        label: 'Request Hive',
        value: attempt === null || attempt === void 0 ? void 0 : attempt.requestIdHive
      }, {
        label: 'Request Liveness',
        value: attempt === null || attempt === void 0 ? void 0 : attempt.requestIdHiveLiveness
      }].filter(function (item) {
        return ['string', 'number'].includes(_typeof(item.value)) && String(item.value).trim();
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          value: String(item.value)
        });
      });
      return {
        raw: attempt,
        originalIndex: originalIndex,
        key: String((attempt === null || attempt === void 0 ? void 0 : attempt._id) || (attempt === null || attempt === void 0 ? void 0 : attempt.requestIdHive) || "face-attempt-".concat(originalIndex + 1)),
        date: date,
        timestamp: Number.isNaN(timestamp) ? null : timestamp,
        image: image,
        score: score,
        scoreLabel: score !== null ? "".concat(score, "%") : null,
        statusLabel: statusLabel,
        spoofLabel: typeof (attempt === null || attempt === void 0 ? void 0 : attempt.spoof) === 'boolean' ? attempt.spoof ? 'Detectado' : 'Não detectado' : null,
        diagnostics: diagnostics,
        identifiers: identifiers,
        errorMessage: errorMessage,
        failureReason: failureReason,
        resultTone: resultTone,
        resultLabel: this.getFaceAttemptResultLabel(resultTone),
        resultTitle: this.getFaceAttemptResultTitle(resultTone),
        hasContent: Boolean(date || image || score !== null || statusLabel || diagnostics.length || identifiers.length || errorMessage || failureReason || typeof (attempt === null || attempt === void 0 ? void 0 : attempt.spoof) === 'boolean')
      };
    },
    extractFaceAttemptDate: function extractFaceAttemptDate() {
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var createdAt = attempt === null || attempt === void 0 ? void 0 : attempt.createdAt;
      return createdAt && !Number.isNaN(new Date(createdAt).getTime()) ? createdAt : null;
    },
    extractFaceAttemptImage: function extractFaceAttemptImage() {
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.normalizeFaceAttemptImage(attempt === null || attempt === void 0 ? void 0 : attempt.selfie);
    },
    normalizeFaceAttemptImage: function normalizeFaceAttemptImage(candidate) {
      var image = typeof candidate === 'string' ? candidate : [candidate === null || candidate === void 0 ? void 0 : candidate.Location, candidate === null || candidate === void 0 ? void 0 : candidate.location, candidate === null || candidate === void 0 ? void 0 : candidate.signedUrl, candidate === null || candidate === void 0 ? void 0 : candidate.url, candidate === null || candidate === void 0 ? void 0 : candidate.URL, candidate === null || candidate === void 0 ? void 0 : candidate.href].find(function (value) {
        return typeof value === 'string' && value.trim();
      });
      if (typeof image !== 'string' || !image.trim()) {
        return null;
      }
      var normalizedImage = image.trim();
      if (/^(https?:|data:image\/|blob:)/i.test(normalizedImage)) {
        return normalizedImage;
      }
      var compactBase64 = normalizedImage.replace(/\s/g, '');
      if (compactBase64.length >= 100 && /^[a-z\d+/=]+$/i.test(compactBase64)) {
        var mimeType = compactBase64.startsWith('/9j/') ? 'image/jpeg' : compactBase64.startsWith('UklGR') ? 'image/webp' : 'image/png';
        return "data:".concat(mimeType, ";base64,").concat(compactBase64);
      }
      if (normalizedImage.startsWith('/')) {
        return normalizedImage;
      }
      return null;
    },
    parseFaceAttemptScore: function parseFaceAttemptScore(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var score = Number(value);
      return Number.isNaN(score) ? null : score;
    },
    formatFaceAttemptStatus: function formatFaceAttemptStatus(value) {
      if (!value) {
        return '';
      }
      var normalizedStatus = String(value).trim().toLowerCase();
      var statusMap = {
        retry: 'Retentativa',
        retentativa: 'Retentativa',
        reprocessing: 'Retentativa',
        reprocessamento: 'Retentativa',
        canceled: 'Cancelado',
        cancelled: 'Cancelado',
        cancelado: 'Cancelado',
        expired: 'Expirado',
        expirado: 'Expirado'
      };
      return statusMap[normalizedStatus] || (0, _livenessBiometricMap.formatBiometricProcessingStatus)(value);
    },
    extractFaceAttemptError: function extractFaceAttemptError() {
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var responseError = attempt === null || attempt === void 0 ? void 0 : attempt.responseError;
      if (typeof responseError === 'string') {
        return responseError;
      }
      if (responseError && _typeof(responseError) === 'object') {
        var nestedMessage = [responseError === null || responseError === void 0 ? void 0 : responseError.message, responseError === null || responseError === void 0 ? void 0 : responseError.error, responseError === null || responseError === void 0 ? void 0 : responseError.details, responseError === null || responseError === void 0 ? void 0 : responseError.detail, responseError === null || responseError === void 0 ? void 0 : responseError.description, responseError === null || responseError === void 0 ? void 0 : responseError.reason].find(function (value) {
          return typeof value === 'string' && value.trim();
        });
        if (nestedMessage) {
          return nestedMessage;
        }
      }
      var directMessage = [attempt === null || attempt === void 0 ? void 0 : attempt.errorMessage, attempt === null || attempt === void 0 ? void 0 : attempt.error].find(function (value) {
        return typeof value === 'string' && value.trim();
      });
      return directMessage || '';
    },
    extractFaceAttemptFailureReason: function extractFaceAttemptFailureReason(_ref) {
      var _ref$attempt = _ref.attempt,
        attempt = _ref$attempt === void 0 ? {} : _ref$attempt,
        _ref$diagnostics = _ref.diagnostics,
        diagnostics = _ref$diagnostics === void 0 ? [] : _ref$diagnostics,
        _ref$score = _ref.score,
        score = _ref$score === void 0 ? null : _ref$score;
      var directReason = [attempt === null || attempt === void 0 ? void 0 : attempt.failureReason, attempt === null || attempt === void 0 ? void 0 : attempt.reason, attempt === null || attempt === void 0 ? void 0 : attempt.errorReason].find(function (value) {
        return typeof value === 'string' && value.trim();
      });
      if (directReason) {
        return directReason;
      }
      var failedDiagnostics = diagnostics.filter(function (item) {
        return item.tone === 'danger';
      }).map(function (item) {
        return item.label;
      });
      if (failedDiagnostics.length) {
        return failedDiagnostics.join(', ');
      }
      if ((attempt === null || attempt === void 0 ? void 0 : attempt.spoof) === true) {
        return 'Tentativa sinalizada com spoofing';
      }
      if (score !== null && score < 0) {
        return 'Score de FaceMatch abaixo do esperado';
      }
      return '';
    },
    getFaceAttemptResultTone: function getFaceAttemptResultTone(_ref2) {
      var rawStatus = _ref2.rawStatus,
        _ref2$diagnostics = _ref2.diagnostics,
        diagnostics = _ref2$diagnostics === void 0 ? [] : _ref2$diagnostics,
        _ref2$score = _ref2.score,
        score = _ref2$score === void 0 ? null : _ref2$score,
        _ref2$errorMessage = _ref2.errorMessage,
        errorMessage = _ref2$errorMessage === void 0 ? '' : _ref2$errorMessage,
        _ref2$attempt = _ref2.attempt,
        attempt = _ref2$attempt === void 0 ? {} : _ref2$attempt;
      var normalizedStatus = String(rawStatus || '').trim().toLowerCase();
      var failedStatuses = ['error', 'erro', 'failed', 'falha', 'canceled', 'cancelled', 'cancelado', 'expired', 'expirado'];
      var hasFailure = diagnostics.some(function (item) {
        return item.tone === 'danger';
      });
      var hasSuccess = diagnostics.length && diagnostics.every(function (item) {
        return item.tone === 'success';
      });
      if (errorMessage || (attempt === null || attempt === void 0 ? void 0 : attempt.spoof) === true || hasFailure || score < 0 || failedStatuses.includes(normalizedStatus)) {
        return 'danger';
      }
      if (hasSuccess || score !== null && score > 0) {
        return 'success';
      }
      if (['completed', 'concluido', 'concluído'].includes(normalizedStatus)) {
        return 'info';
      }
      return 'warning';
    },
    getFaceAttemptResultLabel: function getFaceAttemptResultLabel(tone) {
      var labels = {
        success: 'Aprovada',
        danger: 'Falhou',
        info: 'Concluída',
        warning: 'Em análise'
      };
      return labels[tone];
    },
    getFaceAttemptResultTitle: function getFaceAttemptResultTitle(tone) {
      var titles = {
        success: 'Validação facial aprovada',
        danger: 'Tentativa com falha',
        info: 'Tentativa concluída',
        warning: 'Tentativa sem resultado conclusivo'
      };
      return titles[tone];
    },
    isMainFaceAttempt: function isMainFaceAttempt(attempt, index, total) {
      var _this$currentFaceAtte5;
      var mainDate = this.validationDate;
      var mainTimestamp = mainDate ? new Date(mainDate).getTime() : null;
      var sameDate = attempt.timestamp !== null && mainTimestamp !== null && !Number.isNaN(mainTimestamp) && attempt.timestamp === mainTimestamp;
      var sameImage = Boolean(attempt.image && this.validationFace && attempt.image === this.validationFace);
      if (sameDate || sameImage) {
        return true;
      }
      if (index !== total - 1) {
        return false;
      }
      var mainScore = this.parseFaceAttemptScore((_this$currentFaceAtte5 = this.currentFaceAttempt) === null || _this$currentFaceAtte5 === void 0 ? void 0 : _this$currentFaceAtte5.facematch);
      var sameScore = mainScore !== null && attempt.score !== null && mainScore === attempt.score;
      var mainDiagnostics = this.biometricValidationItems.map(function (item) {
        return "".concat(item.key, ":").concat(item.tone, ":").concat(item.rawValue);
      }).sort().join('|');
      var attemptDiagnostics = attempt.diagnostics.map(function (item) {
        return "".concat(item.key, ":").concat(item.tone, ":").concat(item.rawValue);
      }).sort().join('|');
      var sameDiagnostics = Boolean(mainDiagnostics && mainDiagnostics === attemptDiagnostics);
      return sameScore || sameDiagnostics;
    },
    getFacematchScoreHelper: function getFacematchScoreHelper(score) {
      if (score >= 95) {
        return 'Confiança muito alta na correspondência facial.';
      }
      if (score > 10) {
        return 'Confiança alta na correspondência facial.';
      }
      if (score > 0) {
        return 'Confiança moderada na correspondência facial.';
      }
      if (score === 0) {
        return 'Correspondência neutra, sem evidência conclusiva.';
      }
      return 'Correspondência abaixo do esperado e sujeita a revisão.';
    },
    isAttemptImageAvailable: function isAttemptImageAvailable(attempt) {
      return Boolean((attempt === null || attempt === void 0 ? void 0 : attempt.image) && !this.failedAttemptImages[attempt.key]);
    },
    handleAttemptImageError: function handleAttemptImageError(attemptKey) {
      this.$set(this.failedAttemptImages, attemptKey, true);
    },
    openModal: function openModal(img) {
      this.imgSelected = img;
      this.isImageModalActive = true;
    }
  }
};